import {
  AssetImageType,
  AssetType,
  IAssetImageModel,
  StreamType,
  TimeHelper,
} from "@xala/common-services";
import {
  Col,
  ImageWithPlaceholder,
  Row,
  Skeleton,
  Tag,
  Text,
  Title,
} from "@xala/common-ui";
import cx from "classnames";
import moment from "moment";
import React from "react";
import { IListItemComponentPreviewProps } from "./ListItemComponentPreview";
import "./ListItemCoverComponentPreview.scss";

export interface IListItemCoverComponentPreviewProps
  extends IListItemComponentPreviewProps {}

export class ListItemCoverComponentPreview extends React.Component<
  IListItemCoverComponentPreviewProps
> {
  public static defaultProps: IListItemCoverComponentPreviewProps = {
    isPlaceholder: false,
    width: 0,
  };

  public renderStatus = () => {
    const { asset } = this.props;

    if (!asset) {
      return null;
    }

    const isLiveBroadcast = asset.AssetTypeCode === AssetType.Live;
    let duration = "";

    switch (asset.AssetTypeCode) {
      case AssetType.Live:
      case AssetType.Channel: {
        if (asset.AvailableFrom) {
          const now = moment();
          const availableFrom = moment(asset.AvailableFrom);
          duration = availableFrom.from(now);
        } else {
          duration = TimeHelper.formatDurationMilliseconds(
            asset.DurationMiliseconds
              ? asset.DurationMiliseconds
              : asset.Contents?.find(
                  (c) => c.StreamTypeCode === StreamType.Main
                )?.DurationMiliseconds
          );
        }
        break;
      }
      default:
        duration = TimeHelper.formatDurationMilliseconds(
          asset.DurationMiliseconds
            ? asset.DurationMiliseconds
            : asset.Contents?.find((c) => c.StreamTypeCode === StreamType.Main)
                ?.DurationMiliseconds
        );
    }

    const liveIndicator = isLiveBroadcast && (
      <div className="ListItemCoverComponentPreview-status-online-indicator">
        <Tag color="#f50">Live</Tag>
      </div>
    );
    const durationIndicator = duration && (
      <div className="ListItemCoverComponentPreview-status-duration">
        <Tag color="#2D2D2D">{duration}</Tag>
      </div>
    );

    return (
      <div className="ListItemCoverComponentPreview-status">
        <Row justify="space-between">
          <Col>{liveIndicator}</Col>
          <Col>{durationIndicator}</Col>
        </Row>
      </div>
    );
  };

  public render() {
    const { isHovered, asset, width, placeholderSrc } = this.props;

    let frameImageUrl: string | undefined = "";
    let title: string | undefined = "";
    let description: string | undefined = "";

    if (asset) {
      description = asset.Description;
      title = asset.Title;

      if (asset.Images) {
        const assetFrameImage = asset.Images.find(
          (row: IAssetImageModel) =>
            row.AssetImageTypeCode === AssetImageType.Frame
        );

        if (assetFrameImage) {
          frameImageUrl = assetFrameImage.Url;
        }
      }
    }

    const appListItemPaddingHorizontal = 20;

    const mainStyle: React.CSSProperties = {
      width: `${width}px`,
    };

    const containerStyle: React.CSSProperties = {
      width: `${width - appListItemPaddingHorizontal}px`,
      border: "2px solid #23232e",
      overflow: "hidden",
    };

    const imageContainerStyle: React.CSSProperties = {
      width: `${width - appListItemPaddingHorizontal}px`,
      height: `${Math.round(
        (4 * (width - appListItemPaddingHorizontal)) / 3
      )}px`,
    };

    return (
      <div
        className={cx("ListItemCoverComponentPreview", {
          "ListItemCoverComponentPreview-active": isHovered,
        })}
        style={mainStyle}
      >
        <div style={containerStyle}>
          <div
            className="ListItemCoverComponentPreview-image-container"
            style={imageContainerStyle}
          >
            <ImageWithPlaceholder
              animated={true}
              imageSrc={frameImageUrl}
              imageContainerClassName="ListItemCoverComponentPreview-image"
              placeholderSrc={placeholderSrc}
            />
            {this.renderStatus()}
          </div>
          <div
            className={cx("ListItemCoverComponentPreview-info", {
              "ListItemCoverComponentPreview-info-active": isHovered,
            })}
          >
            <div className="ListItemCoverComponentPreview-info-title-container">
              <Skeleton active={true} loading={!title} paragraph={false}>
                <Row
                  justify="space-between"
                  align="middle"
                  wrap="nowrap"
                  gutter={10}
                >
                  <Col className="ellipsis">
                    <Title
                      className="ListItemCoverComponentPreview-info-title"
                      ellipsis={true}
                      level={4}
                      style={{ margin: 0 }}
                    >
                      {title}
                    </Title>
                  </Col>
                </Row>
              </Skeleton>
            </div>
            <Text
              className="ListItemCoverComponentPreview-info-description"
              style={{ margin: 0 }}
              ellipsis={true}
            >
              <Skeleton
                active={true}
                loading={!description}
                paragraph={false}
                title={{ width: "70%" }}
              >
                {description}
              </Skeleton>
            </Text>
          </div>
        </div>
      </div>
    );
  }
}
